import { supabase } from '../supabase';

interface RegistrationEmailData {
  memberId: string;
  memberName: string;
  tournamentId: string;
  tournamentName: string;
}

export async function sendRegistrationEmail(data: RegistrationEmailData) {
  try {
    console.log('Starting registration email process:', data);
    
    if (!data.memberId || !data.memberName || !data.tournamentId || !data.tournamentName) {
      throw new Error('Missing required email data');
    }

    // Get member email
    const { data: member, error: memberError } = await supabase
      .from('members')
      .select('email')
      .eq('id', data.memberId)
      .single();

    if (memberError) {
      console.error('Failed to fetch member email:', memberError);
      throw memberError;
    }
    
    if (!member?.email) {
      console.error('Member email not found for ID:', data.memberId);
      throw new Error('Member email not found');
    }

    console.log('Calling send-registration-email function with:', {
      recipient_email: member.email,
      template_name: 'registration_confirmation',
      variables: {
        member_name: data.memberName,
        tournament_name: data.tournamentName
      }
    });

    // Call Edge Function to send email
    const { data: response, error } = await supabase.functions.invoke('send-registration-email', {
      body: {
        recipient_email: member.email,
        template_name: 'registration_confirmation',
        variables: {
          member_name: data.memberName,
          tournament_name: data.tournamentName,
          tournament_date: new Date().toLocaleDateString(),
          course_name: 'TBD',
          amount: 'TBD',
          payment_date: new Date().toISOString()
        }
      }
    });

    if (error) {
      console.error('Edge function error:', error);
      throw error;
    }

    if (!response?.success) {
      throw new Error('Email service returned unsuccessful response');
    }

    console.log('Registration email sent successfully');

    return { success: true };
  } catch (error) {
    console.error('Failed to send registration email:', error);
    throw error; // Propagate error up to caller
  }
}